import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ProfileState} from './profile.reducer';

const profileFeatureSelector = createFeatureSelector<ProfileState>('profile');

export const selectProfile = createSelector(profileFeatureSelector, state => state.profile);
